export const detailsDrawerWidth = '50vw';
export const navRailBreakpoint = 'lg';
export const appBarHeight = '64px';
export const fadeInDuration = 450;
export const slideInDuration = 1500;

const APP_BAR_HEIGHT = { xs: 56, sm: 64 };

export const belowAppBar = (offset: string) => ({
  xs: `calc(${APP_BAR_HEIGHT.xs}px + ${offset})`,
  sm: `calc(${APP_BAR_HEIGHT.sm}px + ${offset})`,
  [navRailBreakpoint]: offset,
});

// colors
export const brandAccentColor = 'rgba(255, 122, 0, 1)';
export const brandBackgroundGradient =
  'linear-gradient(90deg, #FF7A00 50%, #FF9801 100%)';
